import React from "react";
import { AnimatePresence } from "framer-motion";
import { FiAlertCircle, FiCheck, FiInfo, FiX } from "react-icons/fi";
// useToastList em vez de useToast: este componente PRECISA re-renderizar
// quando a lista de toasts muda (comportamento desejado). useToast retorna
// so a API estavel — nao tem `toasts` exposto (proposital, evita re-renders
// em consumers que so emitem). Bloco Parenteses 2 fix.
import { useToastList } from "../../context/ToastContext";
import {
  Container,
  ActionButton,
  CloseButton,
  IconWrap,
  Message,
  ToastItem,
} from "./styles";

const ICONS = {
  success: FiCheck,
  danger: FiAlertCircle,
  warning: FiAlertCircle,
  info: FiInfo,
};

export default function ToastStack() {
  const { toasts, remover } = useToastList();
  return (
    <Container>
      <AnimatePresence>
        {toasts.map((t) => {
          const Icon = ICONS[t.tone] || FiInfo;
          return (
            <ToastItem
              key={t.id}
              $tone={t.tone}
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 40 }}
              transition={{ duration: 0.18 }}
            >
              <IconWrap $tone={t.tone}>
                <Icon size={16} />
              </IconWrap>
              <Message>{t.mensagem}</Message>
              {t.actionLabel && t.onAction && (
                <ActionButton
                  type="button"
                  onClick={() => {
                    t.onAction();
                    remover(t.id);
                  }}
                >
                  {t.actionLabel}
                </ActionButton>
              )}
              <CloseButton
                type="button"
                onClick={() => remover(t.id)}
                aria-label="Fechar notificação"
              >
                <FiX size={14} />
              </CloseButton>
            </ToastItem>
          );
        })}
      </AnimatePresence>
    </Container>
  );
}
